import styled from "styled-components";
import * as G from "~/components/global.style";

const headerRowHeight = "100px";

export const Grid = styled.div`
    //display: grid;
    grid-gap: 0px;
    grid-template-columns: 100px 1fr;
    grid-template-rows: ${headerRowHeight} auto 1fr;
    grid-template-areas: 
        "logo header"
        "messages messages"
        "menu content";
    height: 100vh;
`;

export const LogoContainer = styled.div`
    background-color: #2B7092;
    height: ${headerRowHeight};
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${Grid} & { grid-area: logo; }
`;

export const MenuContainer = styled.div`
    background-color: white;
    width: 100px;
    display: flex;
    justify-content: center;
    padding-top: 10px;
    position: absolute;
    top: 100px;
    ${Grid} & { grid-area: menu; }
`;

export const MessagesContainer = styled.div`
    ${Grid} & { grid-area: messages; };
`;

export const HeaderContainer = styled.div`
    background-color: white;
    height: ${headerRowHeight};
    padding-left: 25px;
    display: flex;
    align-items: center;
    ${Grid} & { grid-area: header; }
`;

export const ContentContainer = styled.div`
    /* background-color: #f4f8f9; */
    /*border-left: 1px solid #deecf9;*/
    /*border-top: 1px solid #deecf9;*/
    /* background-color: #8bb2c6; */
    background-color: #F4F8F9;
    padding: 25px;
    position: absolute;
    top: 100px;
    left: 100px;
    width: calc(100% - 100px);
    min-height: calc(100% - 100px);
    box-sizing: border-box;
    
    ${Grid} & { grid-area: content; }

    .ms-DetailsHeader{
        background:  ${G.PrimaryBackgroundColor};
        .ms-DetailsHeader-cellName{
            font-size: 10px;
            color: grey;
        }
    }

    .ms-DetailsRow{
        border-bottom: 3px solid ${G.PrimaryBackgroundColor};

        .ms-DetailsRow-cell{
            /*padding-top: 20px;*/
        }
    }    
`;

export const Logo = styled.div`
    font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
    font-weight: 300;
    color: white;
    display: inline-block;
    font-size: 22px;
    text-align: center;
    span{
        display: block;
        &:first-child{
            line-height: 21px;
        }
        &:last-child{
            font-size: 20px;
            line-height: 18px;
        }
    }
`;


// WEBPACK FOOTER //
// ./src/components/layout/Page.style.ts